import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider";
import { AppVersionNotifier } from "./components/AppVersionNotifier";
import { ThemeProvider } from "./context/ThemeProvider";
import { AppVersionProvider } from "./context/AppVersionProvider";
import { NotificationCenterProvider } from "./features/notifications/NotificationCenterProvider";
import { PushNotificationProvider } from "./features/notifications/PushNotificationProvider";
import { AppRoutes } from "./router";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PushNotificationProvider>
          <NotificationCenterProvider>
            <ThemeProvider>
              <AppVersionProvider>
                <AppVersionNotifier />
                <AppRoutes />
              </AppVersionProvider>
            </ThemeProvider>
          </NotificationCenterProvider>
        </PushNotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
